// src/redux/slices/clientSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ApiGetClientDbName, ApiGetClientEntity, ApiGetClientEntityByClientGroupId } from '../apiService/Core/Apicall.tsx';
import { string } from 'yup';

// Define the Client type (adjust based on your API response)
export interface Business {
    clientEntityId: string;
    entityName: string;
  // add other properties if available
}

// State type
interface BusinessState {
  businessList: Business[];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: BusinessState = {
  businessList: [],
  loading: false,
  error: null,
};

// Async thunk
export const fetchBusinessList = createAsyncThunk<Business[], string>(
  'business/fetchBusinessList',
  async (selectedClient) => {
    const data = `?ClientGroupName=${selectedClient}`;
    const response = await ApiGetClientEntityByClientGroupId(data);
    return response.data;
  }
);

 const businessSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBusinessList.fulfilled, (state, action: PayloadAction<Business[]>) => {
        state.businessList = action.payload;
        state.loading = false;
      })
      .addCase(fetchBusinessList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Something went wrong';
      });
  },
});

export const businessReducer = businessSlice.reducer;
